/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Value_EyebrowInputs */

const en_pricing_page_value_eyebrow = /** @type {(inputs: Pricing_Page_Value_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is inside`)
};

const pl_pricing_page_value_eyebrow = /** @type {(inputs: Pricing_Page_Value_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co jest w środku`)
};

/**
* | output |
* | --- |
* | "What is inside" |
*
* @param {Pricing_Page_Value_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_value_eyebrow = /** @type {((inputs?: Pricing_Page_Value_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Value_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_value_eyebrow(inputs)
	return en_pricing_page_value_eyebrow(inputs)
});